import { ActionIcon, Group, Menu, Text, createStyles } from "@mantine/core";
import {
  IconEdit,
  IconEye,
  IconTrash,
  IconMobiledata,
} from "@tabler/icons-react";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import {
  getPlans,
  movePlanToActive,
  removePlan,
} from "../../services/supportplan";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { setAddPatientLoading } from "../../store/reducers/patient";
import moment from "moment";
import { getNotes } from "../../services/note";
import { isStaff } from "../../http";

const useStyles = createStyles((theme) => ({
  border: {
    borderLeft: "1px solid #F2F2F2",
  },
}));

const PlanTableRow = ({
  row,
  open,
  setView,
  openView,
  segment,
  currentPage,
  client,
  openForce,
}) => {
  const { classes } = useStyles();
  const { profile } = useSelector((state) => state.profile);
  // let userType = profile?.user?.type;

  const Parameters = ({ parameters }) => {
    if (Array.isArray(parameters) && parameters?.length > 1)
      return (
        <Text
          className={classes.cell}
          style={{ display: "flex", alignItems: "center", gap: 20 }}
        >
          {parameters?.[0]?.outcomeTitle ||
            parameters?.[0]?.Identified_Relevant_Attainable_Goals}
          <div
            style={{
              background: "#F0F0F0",
              borderRadius: 5,
              padding: 5,
              width: 50,
              color: "#A8A8A8",
              fontSize: 14,
            }}
          >
            + {parameters?.length - 1}
          </div>
        </Text>
      );

    return (
      <Text className={classes.cell}>
        {Array.isArray(parameters)
          ? parameters
              ?.map(
                (val) =>
                  val?.outcomeTitle ||
                  val?.Identified_Relevant_Attainable_Goals,
              )
              ?.join("")
          : parameters}
      </Text>
    );
  };

  // remove function
  const moveToActive = async () => {
    let res;
    res = await movePlanToActive(row?._id);

    if (res?.status === 201) {
      getPlans(currentPage, client, segment?.toLowerCase());
      getNotes(1, client, false);
    } else if (res?.status === 200) {
      swal({
        title: res?.data?.message,
        text: "",
        icon: "info",
        dangerMode: false,
        buttons: ["Cancel", "Ok"],
      });
    }
  };

  // remove function
  const remove = async () => {
    const willDelete = await swal({
      title: `Are you sure?`,
      text: "This action cannot be undone.",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (willDelete) removePlan(row?._id, row?.client?._id);
    getPlans(currentPage, client, segment?.toLowerCase());
    getNotes(1, client, false);
  };

  function handleRowClick(event) {
    setView(true);
    openView(row);
  }

  return (
    <>
      {segment === "active" ? (
        <tr
          style={{
            cursor: "pointer",
            background: row?.internalDiscontinue !== true ? "#fff" : "#F0F0F0",
          }}
        >
          <td onClick={handleRowClick}>
            {row?.planType?.name || <Text align="center">-</Text>}
          </td>
          <td onClick={handleRowClick}>
            {row?.client?.name || <Text align="center">-</Text>}
          </td>
          <td onClick={handleRowClick}>
            {row?.facility?.name || <Text align="center">-</Text>}
          </td>
          <td onClick={handleRowClick}>
            <Parameters
              parameters={
                row?.planType?._id === "68ae9ad573178c6bd823ac2f"
                  ? row?.goals || <Text align="center">-</Text>
                  : row?.outcomes || <Text align="center">-</Text>
              }
            />
          </td>
          <td>
            {/* <Group>
              <ActionIcon
                id="view-care-plan"
                title="view"
                color="yellow"
                variant="light"
                onClick={(e) => {
                  setView(true);
                  openView(row);
                }}
              >
                <IconEye />
              </ActionIcon>

              <ActionIcon
                id="update-care-plan"
                disabled={
                  profile?.user?.type === "staff" &&
                  profile?.user?.role !== "admin"
                }
                color="green"
                title="edit"
                variant="light"
                onClick={(e) => {
                  open(row);
                  // dispatch(setAddPatientLoading(false));
                  // setView(false);
                }}
              >
                <IconEdit />
              </ActionIcon>
              <ActionIcon
                title="delete"
                disabled={
                  profile?.user?.type === "staff" &&
                  profile?.user?.role !== "admin"
                }
                color="red"
                variant="light"
                onClick={remove}
              >
                <IconTrash />
              </ActionIcon>
            </Group> */}
            <Menu
              shadow="md"
              position="bottom-end"
              withinPortal
              zIndex={"1500"}
            >
              <Menu.Target>
                <ActionIcon>
                  <BiDotsVerticalRounded
                    id="vertical-dots"
                    size={20}
                    color="#000"
                  />
                </ActionIcon>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Item
                  onClick={(e) => {
                    setView(true);
                    openView(row);
                  }}
                >
                  View
                </Menu.Item>
                {!isStaff(profile?.user?.role) ? (
                  <Menu.Item
                    onClick={(e) => {
                      open(row);
                      // dispatch(setAddPatientLoading(false));
                      // setView(false);
                    }}
                  >
                    Edit
                  </Menu.Item>
                ) : null}
                {!isStaff(profile?.user?.role) ? (
                  <Menu.Item onClick={remove}>Delete</Menu.Item>
                ) : null}
              </Menu.Dropdown>
            </Menu>
          </td>
        </tr>
      ) : segment === "discontinued" ? (
        <tr style={{ cursor: "pointer" }}>
          <td>{row?.planType?.name || "-"}</td>
          <td>
            {moment(row?.startDate).format("MM/DD/YYYY") || (
              <Text align="center">-</Text>
            )}
          </td>
          <td>
            {moment(row?.discontinueDate).format("MM/DD/YYYY") || (
              <Text align="center">-</Text>
            )}
          </td>
          <td>{row?.discontinueReason || <Text align="center">-</Text>}</td>
          <td>
            {/* <Group>
              <ActionIcon
                title="view"
                color="yellow"
                variant="light"
                onClick={(e) => {
                  setView(true);
                  openView(row);
                }}
              >
                <IconEye />
              </ActionIcon>
              <ActionIcon
                title="view"
                color="green"
                variant="light"
                onClick={(e) => {
                  openForce(row);
                }}
              >
                <IconMobiledata />
              </ActionIcon>
            </Group> */}
            <Menu
              shadow="md"
              position="bottom-end"
              withinPortal
              zIndex={"1500"}
            >
              <Menu.Target>
                <ActionIcon>
                  <BiDotsVerticalRounded
                    id="vertical-dots"
                    size={20}
                    color="#000"
                  />
                </ActionIcon>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Item
                  onClick={(e) => {
                    setView(true);
                    openView(row);
                  }}
                >
                  View
                </Menu.Item>
                {!isStaff(profile?.user?.role) ? (
                  <Menu.Item
                    onClick={(e) => {
                      openForce(row);
                    }}
                  >
                    Reactivate
                  </Menu.Item>
                ) : null}
              </Menu.Dropdown>
            </Menu>
          </td>
        </tr>
      ) : segment === "draft" ? (
        <tr
          style={{
            cursor: "pointer",
            background: row?.internalDiscontinue !== true ? "#fff" : "#F0F0F0",
          }}
        >
          <td onClick={handleRowClick}>
            {row?.planType?.name || <Text align="center">-</Text>}
          </td>
          <td onClick={handleRowClick}>
            {row?.client?.name || <Text align="center">-</Text>}
          </td>
          <td onClick={handleRowClick}>
            {row?.facility?.name || <Text align="center">-</Text>}
          </td>
          <td onClick={handleRowClick}>
            <Parameters
              parameters={
                row?.planType?._id === "68ae9ad573178c6bd823ac2f"
                  ? row?.goals || <Text align="center">-</Text>
                  : row?.outcomes || <Text align="center">-</Text>
              }
            />
          </td>
          <td>
            <Menu
              shadow="md"
              position="bottom-end"
              withinPortal
              zIndex={"1500"}
            >
              <Menu.Target>
                <ActionIcon>
                  <BiDotsVerticalRounded
                    id="vertical-dots"
                    size={20}
                    color="#000"
                  />
                </ActionIcon>
              </Menu.Target>
              <Menu.Dropdown>
                {!isStaff(profile?.user?.role) ? (
                  <Menu.Item onClick={moveToActive}>Set Active</Menu.Item>
                ) : null}
                <Menu.Item
                  onClick={(e) => {
                    setView(true);
                    openView(row);
                  }}
                >
                  View
                </Menu.Item>
                <Menu.Item
                  disabled={
                    profile?.user?.type === "staff" &&
                    profile?.user?.role !== "admin"
                  }
                  onClick={(e) => {
                    open(row);
                    // dispatch(setAddPatientLoading(false));
                    // setView(false);
                  }}
                >
                  Edit
                </Menu.Item>
                <Menu.Item
                  disabled={
                    profile?.user?.type === "staff" &&
                    profile?.user?.role !== "admin"
                  }
                  onClick={remove}
                >
                  Delete
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </td>
        </tr>
      ) : null}
    </>
  );
};

export default PlanTableRow;
